import request from '@/utils/request.js';

// 查询客户接口api
export function GetUserInfoPageList(data) {
    // 获取用户分页列表
    return request({
        url: '/userInfo/GetUserInfoPageList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function Create(data) {
    // 创建用户
    return request({
        url: '/userInfo/Create',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function UpdateUserInfo(data) {
    // 更新用户
    return request({
        url: '/userInfo/UpdateUserInfo',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetUserInfoEntity(data) {
    // 获取单个用户信息
    return request({
        url: '/userInfo/GetUserInfoEntity?' + `id=${data.Id}`,
        method: 'post',
        apiType: 'java'
    });
}

export function Delete(data) {
    // 删除用户信息
    return request({
        url: '/userInfo/Delete',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function UpdateUserStatus(data) {
    // 更新(批量)用户状态
    return request({
        url: '/userInfo/UpdateUserStatus',
        method: 'post',
        apiType: 'java',
        data: data
    });
}

export function GetUserList(data) {
    // 获取用户列表(不分页)
    return request({
        url: '/userInfo/GetUserList',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetChildUserList(data) {
    // 获取下级用户列表(不分页)
    return request({
        url: '/userInfo/GetChildUserList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function SeacherChildUserList(data) {
    // 获取下级用户列表(不分页)
    return request({
        url: '/userInfo/SeacherChildUserList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function ResetPassword(data) {
    // 修改/重置 密码
    return request({
        url: '/userInfo/ResetPassword',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function NeedChangePassword() {
    // 当前登录用户是否需要被强制修改密码（判定全在后端，前端不传参）
    return request({
        url: '/userInfo/NeedChangePassword',
        method: 'post',
        apiType: 'java'
    });
}

export function UnBindUserPhone(data) {
    //批量解除绑定(状态改为正常)
    return request({
        url: '/userInfo/UnBindUserPhone',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function ImportUser(data) {
    //导入用户
    return request({
        url: '/userInfo/ImportUser',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function GetUserCustomerInfo(data) {
    //用户客户数据[离职继承]
    return request({
        url: '/userInfo/GetUserCustomerInfo',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function DeleteUserCustomerList(data) {
    //删除用户客户信息[离职继承]
    return request({
        url: '/userInfo/DeleteUserCustomerList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function DistributeUserCustomer(data) {
    //分配用户客户[离职继承]
    return request({
        url: '/userInfo/DistributeUserCustomer',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function ExportUserInfo(data) {
    // 导出用户
    return request({
        url: '/userInfo/ExportUserInfo',
        method: 'post',
        apiType: 'java',
        data,
        responseType: 'blob'
    });
}

export function GetUserInfoContainSeatInfoPageList(data) {
    // 用户包含坐席信息分页列表
    return request({
        url: '/userInfo/GetUserInfoContainSeatInfoPageList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function GetEnterpriseUserRenewalNum(data) {
    // 【系统费模式】获取公司剩余续费额度
    return request({
        url: '/userInfo/GetEnterpriseUserRenewalNum?' + `Id=${data.Id}`,
        method: 'post',
        apiType: 'java'
    });
}

export function UserListValidityRenewal(data) {
    // 【系统费模式】批量或者单个续费
    return request({
        url: '/userInfo/UserListValidityRenewal',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function BindWxInfo(data) {
    // 绑定微信
    return request({
        url: '/userInfo/BindWxInfo',
        method: 'post',
        data
    });
}

export function UnBindWxInfo(data) {
    // 微信解除绑定
    return request({
        url: '/userInfo/UnBindWxInfo',
        method: 'post',
        data,
        apiType: 'java'
    });
}
